import client from '../client.js'
import authGql from '@graphql/queries/auth'
import destroySessionGql from '../mutations/destroy-session.gql'

const destroySession = (input) => {
  return client.mutate({
    mutation: destroySessionGql,
    variables: input,
    update: (store, { data }) => {
      if (data.destroySession) {
        // Clear the store safely by first stopping all active queries
        client.stop()

        // Reset the cache and store
        client.cache.reset()
        client.resetStore().catch((error) => {
          console.warn('Error resetting Apollo store:', error)
        })

        // update auth cache
        store.writeQuery({
          query: authGql,
          data: {
            auth: null
          }
        })
      }
    }
  })
}

export default destroySession
